
      import Loading from './loading.vue'
      import type { App, Plugin } from 'vue'

      export const LoadingPlugin: Plugin = {
        install(app: App) {
          app.component('Loading', Loading)
        },
      }
      export { Loading }
      